import {
    SET_LOGIN_API,
    SET_LOGIN_SUCCESSS
} from './types'


const reducer = (state = {},actions) => {
    switch(actions.type) {
        case SET_LOGIN_API:
            return {
                ...state,
                loginAPI: actions.values
            }
        case SET_LOGIN_SUCCESSS:
            return {
                ...state,
                loginSuccess: actions.values
            }
        default:
            return state
    }
}

export default reducer